import PropTypes from 'prop-types';
import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Card from 'react-bootstrap/Card';
import Modal from 'react-bootstrap/Modal';
import { useGetPlans } from '../../../APIs/Plan/plan';
import LoadingSpinner from '../../../components/common/LoadingSpinner/LoadingSpinner';
import { gstRate, hasGst, inr } from '../../../utils/gst';
import './pricingSection.css';

export default function PricingSection({ onSelectPlan, currentPlanId, renewMode = false }) {
  const { plans, isLoading } = useGetPlans();
  const [showDowngradeModal, setShowDowngradeModal] = useState(false);

  const currentPlan = plans?.find((p) => p.id === currentPlanId);
  const currentPlanPrice = currentPlan?.monthly_price || 0;

  const isBlurred = showDowngradeModal;
  if (isLoading) {
    return (
      <div className="py-5 d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
        <LoadingSpinner />
      </div>
    );
  }

  const visiblePlans = plans.filter((p) => !p.is_custom);

  if (!visiblePlans.length) {
    return <div className="text-center text-muted py-5">No plans available</div>;
  }

  return (
    <>
      <div className={`pricing-wrapper ${isBlurred ? 'is-blurred' : ''}`}>
        <Row className="g-4 justify-content-center">
          {visiblePlans.map((plan) => {
            const isCurrent = plan.id === currentPlanId;
            const isDowngrade = currentPlanPrice && plan.monthly_price < currentPlanPrice;

            return (
              <Col md={5} key={plan.id}>
                <Card className={`pricing-card h-100 ${plan.is_popular ? 'popular-plan' : ''}`}>
                  {plan.is_popular && <div className="popular-ribbon">Most Popular</div>}

                  <Card.Body className="d-flex flex-column p-4">
                    {isCurrent && <div className="current-plan-badge">Current Plan</div>}

                    <h5 className="plan-title">{plan.name}</h5>

                    <p className="plan-description">{plan.description}</p>

                    <div className="plan-price">
                      <>
                        ₹{plan.monthly_price}
                        <span className="plan-cycle"> / month</span>
                      </>
                    </div>
                    {/* The GST in rupees and the total that is actually charged,
                        from the server's own sum. Falls back to the old label
                        if an older API sends no breakdown. */}
                    {hasGst(plan.monthly_gst) ? (
                      <div className="plan-gst">
                        + {inr(plan.monthly_gst.gst_amount)} GST ({gstRate(plan.monthly_gst)})
                        <span className="plan-total"> · {inr(plan.monthly_gst.total_amount)} total</span>
                      </div>
                    ) : (
                      <div className="plan-gst">+ 18% GST</div>
                    )}

                    <ul className="feature-list">
                      {plan.features?.map((feature, index) => (
                        <li key={index}>
                          <span className="feature-check">✓</span> {feature}
                        </li>
                      ))}
                    </ul>

                    <Button
                      className="pricing-btn mt-auto w-100"
                      disabled={isCurrent && !renewMode}
                      onClick={() => {
                        if (isDowngrade && !renewMode) {
                          setShowDowngradeModal(true);
                          return;
                        }

                        onSelectPlan({
                          planId: plan.id,
                          billing: 'monthly',
                          price: plan.monthly_price
                        });
                      }}
                    >
                      {isCurrent ? (renewMode ? 'Renew Plan' : 'Current Plan') : 'Choose Plan'}
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            );
          })}
        </Row>
      </div>
      {/* Downgrade Modal */}
      <Modal show={showDowngradeModal} onHide={() => setShowDowngradeModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Plan Downgrade</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          Downgrading your plan before the current billing cycle ends is not allowed.
          <br />
          <br />
          Please contact support if you need assistance.
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDowngradeModal(false)}>
            Close
          </Button>

          <Button
            variant="primary"
            onClick={() => {
              window.location.href = 'mailto:info@seatup.in';
            }}
          >
            Contact Support
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

PricingSection.propTypes = {
  onSelectPlan: PropTypes.func.isRequired,
  currentPlanId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  renewMode: PropTypes.bool
};
